module.exports = __webpack_public_path__ + "img/edit.3de437df.svg";